import Vue from "vue";

const desensitize = (value, type) => {
    if (!value) return '';
    switch (type) {
        case 'phone': // 手机号: 138****5678
            return value.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
        case 'name': // 姓名: 张* 或 欧阳**
            return value.replace(/(?<=[\u4e00-\u9fa5]{1})([\u4e00-\u9fa5]+)/,
                (match) => '*'.repeat(match.length));
        case 'idCard': // 身份证: 4101********1234
            return value.replace(/(\d{4})\d+(\d{4})/, '$1********$2');
        default: // 默认保留第一位
            return value;
    }
}
export default {
    update(el, binding, vnode) {
        Vue.nextTick(() => {
            const input = el.querySelector('input');
            if (!input) return;
            // 保存原始值引用
            let rawValue = binding.value.mode
            let type = binding.value.type
            if (!rawValue && el._isListening) {
                // 解除事件绑定
                input.removeEventListener('blur', el._blurHandler);
                input.removeEventListener('focus', el._focusHandler);
                input.removeEventListener('input', el._inputHandler);
            }
            if (rawValue && !el._isListening) {
                // 失焦时处理函数
                const blurHandler = () => {
                    if (!rawValue) {
                        return
                    }
                    input.value = desensitize(rawValue, type);
                };

                // 聚焦时处理函数
                const focusHandler = () => {
                    if (!rawValue) {
                        return
                    }
                    input.value = rawValue; // 显示原始值
                };

                // 输入时处理函数
                const inputHandler = (e) => {

                    rawValue = e.target.value; // 更新原始值
                };

                // 绑定事件
                input.addEventListener('focus', focusHandler);
                input.addEventListener('blur', blurHandler);
                input.addEventListener('input', inputHandler);
                el._isListening = true;
                // 保存事件引用以便解除绑定
                el._blurHandler = blurHandler;
                el._focusHandler = focusHandler;
                el._inputHandler = inputHandler;
                setTimeout(() => {
                    input.value = desensitize(rawValue, type);
                }, 100)
            }
        })
    },


    unbind(el) {
        const input = el.querySelector('input');
        if (!input) return;
        // 解除事件绑定
        input.removeEventListener('blur', el._blurHandler);
        input.removeEventListener('focus', el._focusHandler);
        input.removeEventListener('input', el._inputHandler);
    }
};

